import { type ColumnOption } from "interfaces/columnOptions";
import { type Account } from "interfaces/Account";
import { Tooltip } from "components/common/tooltip";
import dateTimeUtils from "utils/dateTimeUtils";
import AccountInfo from "./AccountInfo";
import { PermissionTypeToString } from "./constants";
import AccountEllipsisPopupButton from "./AccountEllipsisPopupButton";
import { LabelsOverflow } from "components";

export enum Columns {
  Name = "Name",
  Type = "Account Type",
  Permissions = "Permissions",
  Added = "Added",
}

export const columnToParam = {
  [Columns.Name.toLowerCase()]: "name",
  [Columns.Type.toLowerCase()]: "accountTypeName",
  [Columns.Permissions.toLowerCase()]: "permissionType",
  [Columns.Added.toLowerCase()]: "added",
};

type Props = {
  url: (account: Account) => string;
  onOpenMobo: () => void;
  actionsDisabled: boolean;
  onDeleteAccount?: (id: number, name: string) => void;
};

export const getColumnOptions = ({
  url,
  actionsDisabled,
  onOpenMobo,
  onDeleteAccount,
}: Props): ColumnOption<Account>[] => [
  {
    name: "Name",
    width: 5,
    isSortable: true,
    className: "linked-account-name-header",
    render: (account) => <AccountInfo account={account} url={url(account)} />,
  },
  {
    name: "Account type",
    width: 3,
    isSortable: true,
    render: (account) => <Tooltip target={account.accountTypeName} content={account.accountTypeName} />,
  },
  {
    name: "Labels",
    width: 3,
    isSortable: false,
    render: (account) => <LabelsOverflow labels={account.tags} />,
  },
  {
    name: "Permissions",
    width: 3,
    isSortable: true,
    render: (account) => PermissionTypeToString[account.permissionType],
  },
  {
    name: "Added",
    width: 3,
    isSortable: true,
    render: (account) => dateTimeUtils.formatDate(account.added),
  },
  {
    name: "",
    width: 1,
    isSortable: false,
    className: "align-right",
    render: (account) => (
      <AccountEllipsisPopupButton
        accountId={account.id}
        accountName={account.name}
        onOpenMobo={onOpenMobo}
        disabled={actionsDisabled || !account.canView}
        onDelete={onDeleteAccount}
        canView={account.canView}
        canDelete={account.canDelete}
      />
    ),
  },
];
